//#region src/common/is-valid-url.ts
var e = (e) => {
	try {
		let t = new URL(e);
		return t.protocol === "http:" || t.protocol === "https:";
	} catch {
		return !1;
	}
};
//#endregion
export { e as isValidUrl };
